import { render, staticRenderFns } from "./GemstoneWeights.vue?vue&type=template&id=65e36c29&"
import script from "./GemstoneWeights.vue?vue&type=script&lang=js&"
export * from "./GemstoneWeights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports